<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
<ziro-breadcrumbs></ziro-breadcrumbs>
@if (!isLoading) {
  <div>
    <div class="card bg-light mb-3">
      <div class="card-body">
        <p [innerHTML]="'tkey;admin.site_management.bulk_change.instructions' | escapeHtml"></p>
      </div>
    </div>
    <div class="pb-2">
      <ziro-site-bulk-field-copy-form
        [clusterId]="clusterId"
        [sites]="sites"
        [currentClusterName]="currentClusterName"
      ></ziro-site-bulk-field-copy-form>
    </div>
  </div>
}
